// LoginPage.jsx
import React from 'react';
//import { useNavigate } from 'react-router-dom';
import SavvytronHeader from '../components/SavvytronHeader';

export default function LoginPage() {
  //const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 p-4 sm:p-10 font-sans">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-6 sm:p-10">
        <SavvytronHeader />

        {/* login form */}
        <form className="flex flex-col gap-4 max-w-sm w-full mx-auto p-4">
          <h2 className="text-brand text-xl sm:text-2xl font-semibold text-center mb-4 mt-6">
            Client&nbsp;Login
          </h2>

          <label className="flex flex-col gap-2 text-gray-700 font-medium text-[0.95rem]">
            Username
            <input
              type="text"
              name="username"
              required
              className="w-full px-4 py-3 rounded-lg border border-gray-300 bg-gray-50 text-gray-800 focus:outline-none focus:border-brand focus:ring-1 focus:ring-brand"
            />
          </label>

          <label className="flex flex-col gap-2 text-gray-700 font-medium text-[0.95rem]">
            Password
            <input
              type="password"
              name="password"
              required
              className="w-full px-4 py-3 rounded-lg border border-gray-300 bg-gray-50 text-gray-800 focus:outline-none focus:border-brand focus:ring-1 focus:ring-brand"
            />
          </label>

          <button
            type="submit"
            className="
    w-full sm:w-auto                         /* full-width on phones, auto on ≥ 640 px */
    inline-flex items-center justify-center
    px-6 py-2.5 sm:px-7 sm:py-3             /* matches CTA’s new dimensions */
    rounded-lg
    bg-gradient-to-r from-brand to-brand-hover
    text-sm sm:text-base text-white
    font-medium tracking-wide
    shadow-md hover:shadow-lg
    transition
    hover:scale-[1.02] active:scale-95
    focus:outline-none focus-visible:ring-2 focus-visible:ring-brand
  "
          >
            Login
            {/* optional arrow for consistency — remove if you don’t want it */}
            <svg
              className="w-4 h-4 ml-2 -mr-1"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </button>

        </form>
      </div>
    </div>
  );
}
